import { AccountSelect, AccountSelectProps } from '@components'

import React, { forwardRef, ReactElement, Ref, useCallback } from 'react'

import { Account } from '@modules-deprecated/app/accounts/types'

import { useCreateAccountModal } from '../../hooks/useCreateAccountModal'
import { useIsAccountCreationAvailable } from './hooks/useIsAccountCreationAvailable'

export type AccountSelectWithCreateProps = Omit<AccountSelectProps, 'onCreateNew'>

export const AccountSelectWithCreate = forwardRef(
  ({ natures, onSelect, ...selectProps }: AccountSelectWithCreateProps, ref: Ref<HTMLDivElement>): ReactElement => {
    const isAccountCreationAvailable = useIsAccountCreationAvailable()

    const handleAccountCreated = useCallback(
      (account: Account) => {
        onSelect?.(account.id, account)
      },
      [onSelect],
    )

    const { openCreateAccountModal, createAccountModal } = useCreateAccountModal({
      natures,
      onSave: handleAccountCreated,
    })

    return (
      <>
        <AccountSelect
          {...selectProps}
          natures={natures}
          onCreateNew={isAccountCreationAvailable ? openCreateAccountModal : undefined}
          onSelect={onSelect}
          ref={ref}
        />
        {isAccountCreationAvailable && createAccountModal}
      </>
    )
  },
)
